import React from 'react';
import { shape, string, number } from 'prop-types';
import styled from 'styled-components';

import Tooltip from 'components/Tooltip/Tooltip';
import TrendIndicator from 'components/TrendIndicator/TrendIndicator';
import convertGroupIdToLabel from 'helpers/convertGroupIdToLabel';

import CommentSVG from 'icons/comment.svg';

const Container = styled.div`
  position: absolute;
  top: ${({ top }) => `${top}px`};
  left: ${({ left }) => `${left}px`};
  pointer-events: none;
  transform: translate(-100%, -100%);
`;

const Title = styled.h4`
  font-size: 1em;
  font-weight: 700;
`;

const Row = styled.div`
  display: flex;
`;

const Term = styled.span`
  flex: 0 0 2em;
  margin-right: 1em;
  font-size: 1em;
  font-weight: 400;
  text-transform: uppercase;
  text-align: right;
`;

const Details = styled.span`
  font-family: ${({ theme }) => theme.numbersFontFamily};
`;

const CommentIcon = styled(CommentSVG)`
  width: 20px;

  g {
    fill: white;
  }
`;

const StyledTrendIndicator = styled(TrendIndicator)`
  margin-left: 0.2em;
`;

export default function CirclePackingTooltip({
  node: { id, x, y, score, value, color, trend },
  margin,
}) {
  return (
    <Container top={y} left={x}>
      <Tooltip color={color} showPoint={false}>
        <Title>{convertGroupIdToLabel(id)}</Title>
        <Row>
          <Term>KCI:</Term>
          <Details>{score}</Details>
          <StyledTrendIndicator trend={trend} width={10} />
        </Row>
        <Row>
          <Term>
            <CommentIcon />
          </Term>
          <Details>{value}</Details>
        </Row>
      </Tooltip>
    </Container>
  );
}

CirclePackingTooltip.propTypes = {
  node: shape({
    id: string.isRequired,
    x: number.isRequired,
    y: number.isRequired,
    score: number.isRequired,
    value: number.isRequired,
    color: string,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/CirclePackingChart/CirclePackingTooltip/CirclePackingTooltip.js